import {ConnectedPlatforms, ExternalAuths, PosaPlatforms} from '../../utils/types';
import React, {useCallback, useMemo} from 'react';
import {getPsnCountry} from '../../utils';

import LoginRequired from './RedeemSectionLoginRequired';
import {localizedMessage} from '../message/Message';
import PosaRedeemActions from '../../actions/PosaRedeemActions';
import PsnRegionBlocked from './RedeemSectionPsnRegionBlocked';
import PsnWarning from './RedeemSectionPsnWarning';
import root from 'window-or-global';

interface Props {
  externalAuths: ExternalAuths[];
  connectedPlatforms: ConnectedPlatforms[];
}

const PsnConfirmNextSection = ({externalAuths, connectedPlatforms}: Props) => {
  const psnCountryFromService = useMemo(() => getPsnCountry(externalAuths) || '', [externalAuths]);
  const onClick = useCallback(() => {
    root.scrollTo(0, 0);
    PosaRedeemActions.setPsnCountry(psnCountryFromService);
    PosaRedeemActions.setShowConfirm(true);
  }, [psnCountryFromService]);

  const isRegionBlocked = React.useMemo(
    () =>
      connectedPlatforms.find((item) => {
        return (
          item.platform.toUpperCase() === PosaPlatforms.PSN &&
          !item.redeemable &&
          !item.regionSupported
        );
      }),
    [connectedPlatforms]
  );
  const isCountryMismatch = React.useMemo(
    () =>
      connectedPlatforms.find((item) => {
        return (
          item.platform.toUpperCase() === PosaPlatforms.PSN &&
          !item.redeemable &&
          item.regionSupported
        );
      }),
    [connectedPlatforms]
  );

  if (!psnCountryFromService) {
    return <LoginRequired />;
  }

  if (isRegionBlocked) {
    return <PsnWarning />;
  }

  if (isCountryMismatch) {
    return (
      <PsnRegionBlocked>
        {localizedMessage('epic.code.redemption.posa.page.redeem.regionblocked')}
      </PsnRegionBlocked>
    );
  }

  return (
    <div className="confirm-next-section">
      <button onClick={onClick} disabled={!!isCountryMismatch}>
        {localizedMessage('epic.code.redemption.posa.page.common.next')}
      </button>
      <span>{localizedMessage('epic.code.redemption.posa.page.redeem.confirm.next')}</span>
    </div>
  );
};

export default PsnConfirmNextSection;
